import searchService from './search.service'
import template from './search.html';
import controller from './search.controller'
import './search.scss'

let module = angular.module('search', [
	'ionic',
	'app.config'
])
.service('Search', searchService)
.config(($stateProvider, $urlRouterProvider) => {
	"ngInject";

	$stateProvider
		.state('tab.search', {
			url: '/search',
			views: {
				'tab-search': {
					template: template,
					controller: controller,
					controllerAs: 'search'
				}
			}
		})
})
.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/search/search.js